import * as Yup from 'yup';

export const CalendarWorkingHoursFormValidationSchema = Yup.object().shape({
  TimeStart: Yup.object()
    .nullable()
    .required('Invalid interval')
    .when(['TimeEnd'], (TimeEnd, schema) =>
      schema.test(
        'isEmpty',
        'Invalid interval',
        record => !TimeEnd || record.value < TimeEnd.value
      )
    ),

  TimeEnd: Yup.object()
    .nullable()
    .required('Invalid interval'),
});
